import { render, staticRenderFns } from "./WorkItemType.vue?vue&type=template&id=07751a6b&scoped=true&"
import script from "./WorkItemType.vue?vue&type=script&lang=js&"
export * from "./WorkItemType.vue?vue&type=script&lang=js&"
import style0 from "./WorkItemType.vue?vue&type=style&index=0&id=07751a6b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07751a6b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCard,VCardText,VIcon,VSpacer,VToolbar,VToolbarTitle})
